// extracted by mini-css-extract-plugin
export default {"container":"E8Bmun","user-email":"l3MdLW","userEmail":"l3MdLW","logout-wrapper":"Tw6OAo","logoutWrapper":"Tw6OAo","logout":"c0RbW8"};